/* eslint-disable react/no-array-index-key */
/** @jsxImportSource @emotion/react */
import Box from '@mui/material/Box';
import reactStringReplace from 'react-string-replace';
import {
  isOrderedList,
  isUnorderedList,
  isContentLineContainingIcon,
} from './SummaryContent.helpers';
import MatchIcon from './icons/MatchIcon';
import makeSummaryContentStyling from './makeSummaryContentStyling';
import PhoneIcon from './icons/PhoneIcon';

const SummaryContent = ({ children, spacing }) => {
  const classes = makeSummaryContentStyling();

  const contentSplitOnNewLines = children
    .split('\n')
    .filter((content) => content);

  if (contentSplitOnNewLines.length < 1) {
    return children;
  }

  if (isOrderedList(contentSplitOnNewLines)) {
    return (
      <ol>
        {contentSplitOnNewLines.map((contentLine, index) => (
          <li key={index}>{contentLine.substring(3)}</li>
        ))}
      </ol>
    );
  }
  if (isUnorderedList(contentSplitOnNewLines)) {
    return (
      <ul>
        {contentSplitOnNewLines.map((contentLine, index) => (
          <li key={index}>{contentLine.substring(2)}</li>
        ))}
      </ul>
    );
  }
  return (
    <>
      {contentSplitOnNewLines.map((contentLine, index) => (
        <Box
          key={index}
          marginTop={spacing}
          className={
            isContentLineContainingIcon(contentLine)
              ? classes.textWithIconContainer
              : undefined
          }
        >
          {reactStringReplace(contentLine, /(\[icon-\w+?\])/, (match) => {
            if (match === '[icon-match]') {
              return <MatchIcon />;
            }
            if (match === '[icon-phone]') {
              return <PhoneIcon />;
            }
          })}
        </Box>
      ))}
    </>
  );
};

export default SummaryContent;
